import {
  CheckCircle,
  ClipboardList,
  MessageCircle,
  PenLine,
} from "lucide-react";
import "../../styles/Stats.css";

const steps = [
  {
    icon: MessageCircle,
    title: "Écouter",
    text: "Partir de votre situation réelle, avec ses urgences et ses contraintes.",
  },
  {
    icon: ClipboardList,
    title: "Qualifier",
    text: "Clarifier les faits, les pièces utiles et les interlocuteurs concernés.",
  },
  {
    icon: PenLine,
    title: "Préparer",
    text: "Structurer un courrier, une réclamation ou un dossier compréhensible.",
  },
  {
    icon: CheckCircle,
    title: "Avancer",
    text: "Identifier les prochaines démarches possibles et garder une trace claire.",
  },
];

const Stats = () => {
  return (
    <section className="stats-section" aria-label="Parcours d'accompagnement">
      <div className="stats-container">
        <div className="stats-header">
          <p className="stats-kicker">Une méthode simple</p>
          <h2 className="stats-title">Reprendre la main étape par étape.</h2>
          <p className="stats-subtitle">
            Pas de chiffres inventés ni de promesses automatiques : l'objectif
            est de rendre la situation plus lisible pour mieux agir.
          </p>
        </div>

        <div className="stats-grid">
          {steps.map((step, index) => (
            <article className="stat-card" key={step.title}>
              <div className="stat-card-number">
                {String(index + 1).padStart(2, "0")}
              </div>
              <div className="stats-icon">
                <step.icon size={25} />
              </div>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
